// src/pages/ReleaseDepositPage.jsx
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Layout from "../components/Layout";
import Button from "../components/Button";
import "./ReleaseDepositPage.css";
import PageHeader from "../components/PageHeader";
import { releaseDeposit } from "../services/depositService";
import { useLocation, useNavigate } from "react-router-dom";


function ReleaseDepositPage() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const depositId = queryParams.get("depositId");
  const token = queryParams.get("token");
  
  // Si depositId ou token n'est pas fourni, on affiche un message d'erreur.
  if (!depositId || !token) {
    return (
      <div className="release-container">
        <PageHeader
          title={t("releaseDeposit.pageErrorTitle")}
          subtitle= {t("releaseDeposit.pageErrorSubtitle")}
        />
      </div>
    );
  }

  const handleRelease = async () => {
    setLoading(true);
    setError("");
    setMessage("");
    try {
      await releaseDeposit(depositId, token);
      setMessage(t("releaseDeposit.success"));
      setTimeout(() => navigate("/"), 3000);
    } catch (error) {
      setMessage(`${t("releaseDeposit.error")} - ${error.message}`);
      setLoading(false);
    } 
  };

  return (
    <Layout>
      <div className="release-container">
        <PageHeader
          title={t("releaseDeposit.title")}
          subtitle={t("releaseDeposit.description")}
        />
        <Button 
          label={loading ? t("releaseDeposit.loading") : t("releaseDeposit.submitButton")} 
          onClick={handleRelease} 
          disabled={loading}
          type="button"
        />
        {error && <p className="error">{error}</p>}
        {message && <p className="message">{message}</p>}
      </div>
    </Layout>
  );
}

export default ReleaseDepositPage;
